import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MATERIAL_MODULES } from '../../material.config';

// Importa el componente (que deberá ser standalone)
// import { ColumnSelectorComponent } from './column-selector/column-selector.component';

// Array con todo lo que necesita ColumnSelectorComponent
export const MATERIAL_LIST_IMPORTS = [
  CommonModule,
  FormsModule,
  ...MATERIAL_MODULES,
];

// Exportamos el componente para usarlo directamente
// export { ColumnSelectorComponent };